const TENANT_STORAGE_KEY = 'selected_tenant_id';

export const setSelectedTenant = (tenantId) => {
  if (tenantId) {
    localStorage.setItem(TENANT_STORAGE_KEY, tenantId.toString());
  } else {
    localStorage.removeItem(TENANT_STORAGE_KEY);
  }
};

export const getSelectedTenant = () => {
  return localStorage.getItem(TENANT_STORAGE_KEY);
};

export const clearSelectedTenant = () => {
  localStorage.removeItem(TENANT_STORAGE_KEY);
};
